<template>
  <section id="asociados" class="asociados-section">
    <!-- Ambient Tech Glows -->
    <div class="asociados-bg" aria-hidden="true">
      <div class="glow-orb orb-1"></div>
      <div class="glow-orb orb-2"></div>
      <div class="asociados-grid"></div>
    </div>

    <div class="asociados-container">
      <!-- Encabezado de Sección -->
      <div class="asociados-header">
        <div class="header-badge">
          <i class="fas fa-handshake"></i>
          <span>ALIANZAS ESTRATÉGICAS</span>
        </div>
        <h2 class="asociados-title">
          Nuestras Empresas <span class="text-gradient">Asociadas</span>
        </h2>
        <p class="asociados-subtitle">
          Trabajamos de la mano con marcas líderes e innovadoras en tecnología, software y telecomunicaciones.
        </p>
      </div>

      <!-- Grid de las 3 Empresas Asociadas -->
      <div class="asociados-grid-cards">
        <div
          v-for="(asociado, index) in empresasAsociadas"
          :key="asociado.id"
          class="asociado-card"
          :style="{ '--card-delay': `${index * 0.1}s` }"
        >
          <div class="card-glow-layer"></div>
          <div class="card-border-line"></div>

          <!-- Header de Tarjeta: Tag de categoría y status -->
          <div class="card-top-bar">
            <span class="category-tag">
              <i :class="asociado.iconoTag"></i>
              {{ asociado.categoria }}
            </span>
            <span class="partner-status">
              <span class="status-dot"></span>
              Aliado Oficial
            </span>
          </div>

          <!-- Logo de la Empresa Asociada -->
          <div class="logo-container">
            <div class="logo-backdrop"></div>
            <img 
              :src="asociado.logo" 
              :alt="asociado.nombre" 
              class="asociado-logo"
              loading="lazy"
            />
          </div>

          <!-- Información de la Empresa -->
          <div class="card-body">
            <h3 class="asociado-name">{{ asociado.nombre }}</h3>
            <p class="asociado-desc">{{ asociado.descripcion }}</p>
          </div>

          <!-- Botón de Enlace Externo -->
          <div class="card-footer">
            <a 
              :href="asociado.url" 
              target="_blank" 
              rel="noopener noreferrer"
              class="btn-asociado"
              :class="asociado.btnStyle"
            >
              <span>{{ asociado.btnTexto }}</span>
              <i :class="asociado.btnIcono"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import logoSystems from '@/assets/Img/Servicios/logo-systems.png';
import logoInter from '@/assets/icons/inter.png';
import logoKaos from '@/assets/icons/kaosnet-logo.png';

export default {
  name: 'EmpresasAsociadas',
  data() {
    return {
      empresasAsociadas: [
        {
          id: 'systems-jj',
          nombre: 'Sistemas JJ (System JJ)',
          categoria: 'Software Administrativo',
          iconoTag: 'fas fa-chart-line',
          descripcion: 'Soluciones integrales de software administrativo, facturación, inventario y control comercial para empresas.',
          logo: logoSystems,
          url: 'https://www.sistemas-jj.com',
          btnTexto: 'Visitar Sitio Web',
          btnIcono: 'fas fa-external-link-alt',
          btnStyle: 'btn-cyan'
        },
        {
          id: 'inter',
          nombre: 'Inter Telecomunicaciones',
          categoria: 'Telecomunicaciones & Fibra',
          iconoTag: 'fas fa-satellite-dish',
          descripcion: 'Líder en conectividad de fibra óptica de alta velocidad, televisión digital e Internet corporativo.',
          logo: logoInter,
          url: 'https://inter.com.ve',
          btnTexto: 'Visitar Sitio Web',
          btnIcono: 'fas fa-external-link-alt',
          btnStyle: 'btn-blue'
        },
        {
          id: 'kaos-net',
          nombre: 'Kaos Net',
          categoria: 'Redes & Conectividad',
          iconoTag: 'fas fa-wifi',
          descripcion: 'Especialistas en infraestructura de redes, telecomunicaciones avanzadas y conectividad integral.',
          logo: logoKaos,
          url: 'https://www.instagram.com/kaosnet23',
          btnTexto: 'Ver en Instagram',
          btnIcono: 'fab fa-instagram',
          btnStyle: 'btn-insta'
        }
      ]
    };
  }
};
</script>

<style scoped>
/* ============================================================
   SECCIÓN EMPRESAS ASOCIADAS (LIVIANA, RÁPIDA Y VISUAL)
   ============================================================ */
.asociados-section {
  position: relative;
  width: 100%;
  padding: 3.5rem 1rem 4rem 1rem;
  background-color: #030812;
  font-family: 'Poppins', sans-serif;
  overflow: hidden;
  isolation: isolate;
  border-bottom: 1px solid rgba(0, 229, 255, 0.12);
}

/* Fondos y Efectos */
.asociados-bg {
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 0;
  overflow: hidden;
}

.glow-orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(130px);
  opacity: 0.18;
}

.orb-1 {
  width: 450px;
  height: 450px;
  background: #00e5ff;
  top: -100px;
  left: 10%;
}

.orb-2 {
  width: 450px;
  height: 450px;
  background: #7c3aed;
  bottom: -100px;
  right: 10%;
}

.asociados-grid {
  position: absolute;
  inset: 0;
  background-image:
    linear-gradient(rgba(0, 229, 255, 0.025) 1px, transparent 1px),
    linear-gradient(90deg, rgba(0, 229, 255, 0.025) 1px, transparent 1px);
  background-size: 42px 42px;
  background-position: center;
  mask-image: radial-gradient(circle at center, #000 50%, transparent 90%);
  -webkit-mask-image: radial-gradient(circle at center, #000 50%, transparent 90%);
}

.asociados-container {
  position: relative;
  z-index: 2;
  max-width: 1240px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* ============================================================
   ENCABEZADO
   ============================================================ */
.asociados-header {
  text-align: center;
  max-width: 780px;
  margin-bottom: 2.2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.header-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.32rem 1.1rem;
  border-radius: 999px;
  background: rgba(0, 229, 255, 0.08);
  border: 1px solid rgba(0, 229, 255, 0.35);
  color: #7ef0ff;
  font-size: 0.74rem;
  font-weight: 700;
  letter-spacing: 2px;
  box-shadow: 0 0 15px rgba(0, 229, 255, 0.15);
  margin-bottom: 0.8rem;
  text-transform: uppercase;
}

.header-badge i {
  color: #00e5ff;
}

.asociados-title {
  font-size: 2.1rem;
  font-weight: 800;
  color: #ffffff;
  line-height: 1.2;
  margin: 0 0 0.6rem;
}

@media (min-width: 768px) {
  .asociados-title {
    font-size: 2.5rem;
  }
}

.text-gradient {
  background: linear-gradient(135deg, #ffffff 0%, #7ef0ff 50%, #00e5ff 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.asociados-subtitle {
  font-size: 0.95rem;
  color: #94a3b8;
  line-height: 1.5;
  margin: 0;
}

/* ============================================================
   GRID DE TARJETAS
   ============================================================ */
.asociados-grid-cards {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.5rem;
  width: 100%;
}

@media (max-width: 992px) {
  .asociados-grid-cards {
    grid-template-columns: 1fr;
    max-width: 500px;
    margin: 0 auto;
  }
}

/* Tarjeta de Asociado */
.asociado-card {
  position: relative;
  background: rgba(11, 23, 42, 0.82);
  border: 1.5px solid rgba(0, 229, 255, 0.22);
  backdrop-filter: blur(12px);
  border-radius: 20px;
  padding: 1.6rem;
  display: flex;
  flex-direction: column;
  transition: transform 0.3s cubic-bezier(0.2, 0.8, 0.2, 1), 
              border-color 0.3s ease, 
              box-shadow 0.3s ease;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.5);
  overflow: hidden;
  will-change: transform;
}

.card-border-line {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, transparent, #00e5ff, transparent);
  opacity: 0.5;
  transition: opacity 0.3s ease;
}

.card-glow-layer {
  position: absolute;
  top: -50px;
  right: -50px;
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(0, 229, 255, 0.3) 0%, transparent 70%);
  opacity: 0;
  transition: opacity 0.3s ease;
  pointer-events: none;
}

/* Hover de la Tarjeta */
.asociado-card:hover {
  transform: translateY(-8px);
  border-color: #00e5ff;
  box-shadow: 0 16px 40px rgba(0, 229, 255, 0.25);
  background: rgba(13, 27, 48, 0.92);
}

.asociado-card:hover .card-glow-layer {
  opacity: 1;
}

.asociado-card:hover .card-border-line {
  opacity: 1;
  background: linear-gradient(90deg, #00e5ff, #7ef0ff, #00e5ff);
}

/* Barra Superior */
.card-top-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 1.2rem;
  gap: 0.5rem;
}

.category-tag {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  background: rgba(0, 229, 255, 0.1);
  border: 1px solid rgba(0, 229, 255, 0.25);
  color: #7ef0ff;
  padding: 0.25rem 0.65rem;
  border-radius: 6px;
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.3px;
}

.partner-status {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.72rem;
  color: #10b981;
  font-weight: 600;
}

.status-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #10b981;
  box-shadow: 0 0 8px #10b981;
}

/* Contenedor del Logo */
.logo-container {
  position: relative;
  width: 100%;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(2, 6, 23, 0.65);
  border: 1px solid rgba(0, 229, 255, 0.15);
  border-radius: 14px;
  margin-bottom: 1.3rem;
  overflow: hidden;
  transition: all 0.3s ease;
}

.asociado-card:hover .logo-container {
  border-color: rgba(0, 229, 255, 0.4);
  background: rgba(4, 10, 30, 0.85);
}

.asociado-logo {
  max-width: 80%;
  max-height: 80px;
  object-fit: contain;
  transition: transform 0.3s ease, filter 0.3s ease;
  filter: drop-shadow(0 4px 10px rgba(0, 0, 0, 0.6));
}

.asociado-card:hover .asociado-logo {
  transform: scale(1.08);
  filter: drop-shadow(0 6px 16px rgba(0, 229, 255, 0.5));
}

/* Cuerpo de Tarjeta */
.card-body {
  flex: 1;
  display: flex;
  flex-direction: column;
  margin-bottom: 1.4rem;
}

.asociado-name {
  font-size: 1.15rem;
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 0.5rem;
  line-height: 1.3;
  transition: color 0.3s ease;
}

.asociado-card:hover .asociado-name {
  color: #00e5ff;
}

.asociado-desc {
  font-size: 0.85rem;
  color: #94a3b8;
  line-height: 1.5;
  margin: 0;
}

/* Botón de Acción */
.card-footer {
  width: 100%;
}

.btn-asociado {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.6rem;
  width: 100%;
  padding: 0.75rem 1.2rem;
  border-radius: 12px;
  text-decoration: none;
  font-size: 0.9rem;
  font-weight: 700;
  transition: all 0.3s ease;
  box-sizing: border-box;
}

/* Variantes de Botones */
.btn-cyan {
  background: linear-gradient(135deg, #00e5ff 0%, #1a73e8 100%);
  color: #030812;
  box-shadow: 0 4px 15px rgba(0, 229, 255, 0.35);
}

.btn-cyan:hover {
  box-shadow: 0 0 25px rgba(0, 229, 255, 0.7);
  transform: translateY(-2px);
}

.btn-blue {
  background: linear-gradient(135deg, #1a73e8 0%, #0056b3 100%);
  color: #ffffff;
  border: 1px solid rgba(0, 229, 255, 0.3);
  box-shadow: 0 4px 15px rgba(26, 115, 232, 0.35);
}

.btn-blue:hover {
  background: linear-gradient(135deg, #00e5ff 0%, #1a73e8 100%);
  color: #030812;
  box-shadow: 0 0 25px rgba(0, 229, 255, 0.7);
  transform: translateY(-2px);
}

.btn-insta {
  background: linear-gradient(135deg, #833ab4 0%, #fd1d1d 50%, #fcb045 100%);
  color: #ffffff;
  box-shadow: 0 4px 15px rgba(253, 29, 29, 0.35);
}

.btn-insta:hover {
  box-shadow: 0 0 25px rgba(253, 29, 29, 0.65);
  transform: translateY(-2px);
}
</style>

